import React, { useEffect, useState } from "react";
import TypingProps from "../types/TypingProps";

const Typing: React.FC<TypingProps> = ({ text, speed = 480, delay = 1000 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (index < text.length) {
      // type next character
      timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[index]);
        setIndex(index + 1);
      }, speed);
    } else {
      // full text typed, wait for 'delay' [could be deem as lifespan], then clear and restart
      timeout = setTimeout(() => {
        setDisplayedText("");
        setIndex(0);
      }, delay);
    }

    return () => clearTimeout(timeout);
  }, [index, text, speed, delay]);

  return <span>{displayedText}</span>;
};

export default Typing;